var _linearGradient, _linearGradient2, _linearGradient3, _radialGradient, _linearGradient4, _linearGradient5, _linearGradient6, _radialGradient2, _radialGradient3, _linearGradient7, _radialGradient4, _radialGradient5, _linearGradient8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaSportlotoMatchball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100.6 101.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 54.885,
    y1: 80.017,
    x2: 74.599,
    y2: 68.637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32b6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#98e2f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5f9ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m33.8 70.4 3.4-5s9.7-3.7 14.1-5 6.7-.7 8.7-.3c2 0 11.1 9.7 16.1 18.1 5 8.7 5 11.7 3.4 12.7-2.2 1.2-28.3-6.8-45.7-20.5z",
    fill: "url(#a)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 60.108,
    y1: 25.788,
    x2: 70.994,
    y2: 32.933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32b6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#98e2f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5f9ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32.1 25.1s1 10.7 5 12.4 22.8 4 23.1 4 7-6.4 11.1-12.7c4-6.4 7.7-10.7 9-15.1 1.4-4.3-15-8.7-48.2 11.4z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 26.759,
    y1: 22.391,
    x2: 31.182,
    y2: 75.462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98e2f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#32b6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#87dbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#3cbaee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98e2f0"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 13.12,
    cy: 982.322,
    r: 37.701,
    gradientTransform: "matrix(1 0 0 .7364 0 -672.945)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#98e2f0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#a0e6f3",
    stopOpacity: 0.283
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#b5f0f9",
    stopOpacity: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#c7f8ff"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "url(#e)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 17.225,
    y1: 21.887,
    x2: 16.999,
    y2: 79.948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#92d744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#55682b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#57692d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5c6e34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopColor: "#65773f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#738350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#859266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#9aa682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#b4bda2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#d3d8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#f4f5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#55682b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#2f3130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    stopColor: "#55682b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#92d744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#55682b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#a6d739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#a1d038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#8ab034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#769631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#68812e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#5d732c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#576b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#55682b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#586e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#6d9335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7db13b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#89c640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#90d343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#92d744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#d0d1d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#aaabaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#898a89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6d6e6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#565757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#444645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#383a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#313332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2f3130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#353a2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#47532d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#51632b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#55682b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M23.7 26.1s-6.4-4-9.4-3.7-2.7 2.7-1.3 5.7 7 10.1 10.1 14.4 3.4 7.7 3 10.7c-.3 3-2.3 6-5.4 10.1s-3.4 4.4-6 8c-2.3 4-4.4 7.4-.3 7.4 3.7-.3 10.1-4.7 10.1-4.7s-11.7 9.7-14.7 5.4c-3-4.4-1.3-57.3.3-58.3.6-1 6.3-.6 13.6 5z",
    fill: "url(#f)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 26.926,
    y1: 88.304,
    x2: 76.446,
    y2: 73.046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#57474d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#57484d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#5b5353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#5d5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5e5c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#fffdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#0b0b0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#57474d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#59494f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#5f5055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#6a5b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#7a6c71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#8e8287"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#a79ea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c5bec1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#e6e2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#fffdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#fcfafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#f2f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#e1dfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c9c7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#aba9a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#868481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#5e5c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#57474d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#5a4c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#6d666a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#797679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#7d7c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#7b7a7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#767575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#6c6b6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#5f5d59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#5e5c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#1d1610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fffdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#fffdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#0b0b0d"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.4 78.4s-1.7 0 2.3-5c4.4-5 7.4-7.4 10.1-8 2.7-.3 5.4-.3 8.7 2 3.4 2.3 12.4 10.4 18.8 15.1s12.4 7.4 14.1 7c1.7-.7 1.3-5.4-2-10.4-3.4-5-6.7-9-6.7-9s1.3.3 1 .3 3.4 3 7 9.7c1 2 7 11.7 1 12.1.3.3-23.8-1.4-54.3-13.8z",
    fill: "url(#g)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: -2.905,
    y1: 45.083,
    x2: 20.909,
    y2: 55.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#dced4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#d2ea41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#c7e742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#aadf45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#93d847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#7ecc48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    stopColor: "#61bc49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56b649"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9 79.7c-12.1-17.4-12.1-40.8.3-58.2-.3 4 1 5.4 2.7 8.7 2 3.7 8 11.1 9.7 14.7 2 3.7 2 5.4 1 11.1s-8 12.1-11.4 16.8c-2 2.6-2.3 5.3-2.3 6.9z",
    fill: "url(#h)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 47.765,
    cy: 1049.652,
    r: 33.858,
    gradientTransform: "matrix(1 0 0 .7121 0 -668.321)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#d4d6d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a3a7aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edefef"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79 92.5c-18.8 13.1-44.6 11.4-61.6-3.7.7-2.3 2-4.4 4-7.4 3-4.4 10.7-13.7 14.1-14.7s9 1.3 12.7 4.4c4 3 14.7 13.4 22.4 17.8 4.1 2.2 6.7 3.2 8.4 3.6z",
    fill: "url(#i)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 40.378,
    cy: 531.487,
    r: 31.834,
    fx: 41.065,
    fy: 503.269,
    gradientTransform: "matrix(.9991 -.0419 .0629 1.4971 -5.662 -745.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#a2e6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#35bdfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#297ac0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#224f9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2a9ff4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M88.7 17.8c16.1 19.1 15.7 47.2-.3 66-1 0-1.7-.3-2.7-1C82 81.1 59.6 64 57.9 61.3c-2-2.7-5-6.4-5-10.1s1.7-6.4 3.4-8.4 5.7-5.7 12.4-11.4S83 19.8 86.1 18.1c1 0 2-.3 2.6-.3z",
    fill: "url(#j)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 39.226,
    y1: 16.735,
    x2: 74.641,
    y2: 29.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#951a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#a82704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#be3609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#cf410d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#da4910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#e14e12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#e34f12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#951a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#f55824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f35723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#ec5221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#e14b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#d04016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#ba320e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#9f2004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#951a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#951a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#a02104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#c53912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#df4a1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#ef5422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#f55824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#f35723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#ec5221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#e14b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#d04016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#ba320e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#9f2004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#951a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#1d1610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fffdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#fffdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#1d1610"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 30.2s4.4 7.4 9 7.7 8.4-2 12.7-6 12.4-11.1 17.8-14.7c5-3.7 9-5.7 10.4-4.4s.7 4-2.7 9-5 7.7-4.7 7.4 5-6 8.4-11.7 2-7.4.7-8c-1.3-.7-7-.7-23.8 9-17.4 9.7-27.8 11.7-27.8 11.7z",
    fill: "url(#k)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: -52.081,
    cy: 823.592,
    r: 37.516,
    gradientTransform: "matrix(.9903 -.1386 .1234 .8818 -11.447 -705.376)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#f6be3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#f6b33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#f69634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#f56727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#f56627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#f67c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#f79932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#f8a434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#f89a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#f77f2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f55824"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M80 9.7c-1 0-2.7.3-4.4 1-3.7 1.7-11.1 7-21.1 15.7-7 6-17.1 16.1-25.8 5.7-2-3-11.7-16.1-11.7-19.4 17.5-15.7 43.9-17 63-3z",
    fill: "url(#l)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 70.172,
    cy: 728.008,
    r: 26.69,
    gradientTransform: "translate(0 -696.346)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60c1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#5cbbe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#51a9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#3e8cc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#2464a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#02317f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#002d7c"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M88.7 17.8s-14.1 8.7-20.8 15.1-10.1 8.4-12.7 12.4-3 5.4-1.7 9c1 3.7 4.4 7.7 15.1 15.7C78 77.4 85 82.7 89 83.1l-.7.7c-1 0-1.7-.3-2.7-1-3.6-1.7-26-18.8-27.7-21.5-2-2.7-5-6.4-5-10.1s1.7-6.4 3.4-8.4 5.7-5.7 12.4-11.4S83.1 19.7 86.1 18c1 .1 2-.2 2.6-.2z",
    fill: "url(#m)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 0.281,
    y1: 38.711,
    x2: 10.737,
    y2: 38.711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f564",
    stopOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2.3 45.6c3.4-9 6.4-14.7 8.7-17.8-1-1.7-1.3-3.4-1.3-6.4C2.3 31.8-.4 44.2 1 56c-.4-3.7 0-7.4 1.3-10.4z",
    fill: "url(#n)",
    style: {
      fillRule: "evenodd"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M12 21.8s2-2 11.7 4.4 24.1 18.1 25.8 21.1c1.3 3 .3 5.4-3.7 9.4-4 3.7-17.8 14.7-22.4 18.1s-9.4 6-12.1 4.7C8.7 77.7 8 33.9 12 21.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaSportlotoMatchball);
export default __webpack_public_path__ + "static/media/russia_sportloto_matchball.8c0c16515dd2c583f08f37d967371991.svg";
export { ForwardRef as ReactComponent };